export default __webpack_public_path__ + "static/media/Flowair.680accba.png";